import React from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormLayout from '~/components/formLayout/formLayout';

const IngredientForm = ({ errors, values, touched, handleSubmit, isSubmitting, buttonText }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Ingredient overview">
        <div className="mb3">
          <Label>Name</Label>
          <FormikInputField name="name" invalid={!!errors.name} />
          {errors.name && (
            <p data-qa="name-error" className="error">
              {errors.name}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>Customs name</Label>
          <FormikInputField name="customsName" />
        </div>
        <div className="mb3">
          <Label>Description</Label>
          <FormikInputField type="textarea" name="description" />
        </div>
        <div className="mb3">
          <Label>Ingredient type</Label>
          <FormikInputField type="select" name="type" invalid={!!errors.type}>
            <option value="GRAIN">Grain</option>
            <option value="HOPS">Hops</option>
            <option value="YEAST">Yeast</option>
            <option value="MISC">Miscellaneous</option>
          </FormikInputField>
          {errors.type &&
            touched.type && (
              <p data-qa="type-error" classtype="error">
                {errors.type}
              </p>
            )}
        </div>
        <div className="mb3">
          <Label>How the ingredient is measured</Label>
          <FormikInputField type="select" name="measurementType" invalid={!!errors.measurementType}>
            <option value="KG">Kilograms</option>
            <option value="G">Grams</option>
            <option value="L">Litres</option>
            <option value="ML">Millilitres</option>
          </FormikInputField>
          {errors.measurementType &&
            touched.measurementType && (
              <p data-qa="measurementType-error" className="error">
                {errors.measurementType}
              </p>
            )}
        </div>
        <div className="mb3 checkbox-container">
          <Label>
            <FormikInputField type="checkbox" name="isTracked" checked={values.isTracked} />
            Do you want to track stock adjustments for this ingredient?
          </Label>
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton data-qa="ingredient-save" color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default IngredientForm;



// WEBPACK FOOTER //
// ./src/components/ingredientForm/ingredientForm.jsx